import HelpIcon from '@mui/icons-material/HelpOutlineRounded';
import LogoutIcon from '@mui/icons-material/LogoutRounded';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import PaymentIcon from '@mui/icons-material/PaymentRounded';
import SettingsIcon from '@mui/icons-material/TuneRounded';

import { ACCOUNT_TYPES } from '#client/constants/accountTypes';
import * as ROUTES from '#client/constants/routes';

export const USER_MENU_ITEM_IDS = {
  ACCOUNT_SETTINGS: 'account-settings',
  BILLING: 'billing',
  ENTERPRISE_LINK: 'enterprise-link',
  HELP: 'help',
  LOGOUT: 'logout',
};

const USER_MENU_ITEMS = {
  [USER_MENU_ITEM_IDS.ACCOUNT_SETTINGS]: {
    icon: SettingsIcon,
    labelId: 'dashboard.component.userMenu.menuItem.accountSettings.label',
    to: ROUTES.accountSettings,
  },
  [USER_MENU_ITEM_IDS.BILLING]: {
    icon: PaymentIcon,
    labelId: 'dashboard.component.userMenu.menuItem.billing.label',
    to: ROUTES.billingPaymentMethods,
  },
  [USER_MENU_ITEM_IDS.ENTERPRISE_LINK]: {
    icon: OpenInNewIcon,
    labelId: 'dashboard.component.userMenu.menuItem.enterpriseLink.label',
    sx: { display: { xs: 'flex', md: 'none' } },
    target: '_blank',
  },
  [USER_MENU_ITEM_IDS.HELP]: {
    icon: HelpIcon,
    labelId: 'dashboard.component.userMenu.menuItem.help.label',
    to: ROUTES.help,
  },
  [USER_MENU_ITEM_IDS.LOGOUT]: {
    divider: 'top',
    icon: LogoutIcon,
    labelId: 'dashboard.component.userMenu.menuItem.logout.label',
    to: ROUTES.logout,
  },
};

const USER_MENU_CONFIGS = {
  [ACCOUNT_TYPES.ENTERPRISE]: [USER_MENU_ITEM_IDS.ENTERPRISE_LINK, USER_MENU_ITEM_IDS.LOGOUT],
  [ACCOUNT_TYPES.STANDARD]: [
    USER_MENU_ITEM_IDS.ACCOUNT_SETTINGS,
    USER_MENU_ITEM_IDS.BILLING,
    USER_MENU_ITEM_IDS.HELP,
    USER_MENU_ITEM_IDS.LOGOUT,
  ],
};

export function getUserMenuConfig(configId) {
  const menuItemIds = USER_MENU_CONFIGS[configId] ?? USER_MENU_CONFIGS[ACCOUNT_TYPES.STANDARD];

  return menuItemIds.map((itemId) => ({
    id: itemId,
    ...USER_MENU_ITEMS[itemId],
  }));
}
